<template>
  <div class="all">
    <div class="middle">
      <span>{{ title }} </span>
      <div
        class="chunk"
        v-for="(item, index) in data"
        :key="index"
        @click="goSp(item)"
      >
        <div class="left">
          <img :src="$RES.FDFS + item.previewImage" />
        </div>
        <div class="mid"></div>
        <div class="right">
          <p>{{ item.title }}</p>
          <p>{{ item.createdTime }}</p>
          <div></div>
          <p
            style="
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            "
          >
            {{ item.digest }}
          </p>
        </div>
      </div>
    </div>
    <el-pagination
      class="elPagination"
      background
      layout="prev, pager, next"
      prev-text="上一页"
      next-text="下一页"
      :page-size="pageSize"
      @current-change="getCurrentPage"
      :total="total"
      :current-page="currt"
    >
    </el-pagination>
  </div>
</template>

<script >
import { formatDate } from "../components/Timedata.js";
import { getPcList } from "@/api/companyDynamic/companyDynamic.js";
export default {
  name: "DynamicDetails",
  data() {
    return {
      title: "",
      data: [],
      listQuery: {
        current: 1,
      },
      scroll: 0,
      total: 0,
      pageSize: 0,
      currt: 0,
      userfrom: null,
    };
  },
  methods: {
    getdata() {
      this.listQuery.name = undefined;
      this.listQuery.subsystemIdentificationCode =
        "1E1FF846F78548E6AC29076215F10CDA";
      console.log("====", this.listQuery);
      getPcList(this.listQuery).then((res) => {
        for (let a = 0; a < res.data.records.length; a++) {
          res.data.records[a].createdTime = formatDate(
            res.data.records[a].createdTime
          );
        }

        this.data = res.data.records;
        this.total = res.data.total;
        this.pageSize = res.data.pageSize;
      
        this.currt = res.data.current;
      });
    },
    back() {
      this.$router.push({ name: "Dynamic", query: { title: "回到主页" } });
    },
    getCurrentPage(e) {
      this.listQuery.current = e;
      sessionStorage.setItem("currentPage", this.listQuery.current);
	  console.log('-----',this.listQuery.current)
      this.getdata();
      window.scrollTo(0, 0);
    },
    goSp(item) {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      window.sessionStorage.setItem("scroll", this.scroll);
      let source = { routerName: "DynamicDetails", rotertitle: this.title };
      Object.assign(item, source);

      this.$mybus.emit("userBehavior", {
        from: this.userfrom,
        moduleLevel1: 5,
        moduleLevel2: item.section,
        moduleLevel3: item.id,
      });
      this.$router.push({
        name: "DynamicSp",
        query: { conten: JSON.stringify(item) },
      });
    },
  },
  created() {
    this.listQuery = JSON.parse(this.$route.query.title);

    if (this.listQuery.keyWord == "1") {
      this.title = "行业动态";
    }
    if (this.listQuery.keyWord == "2") {
      this.title = "九域新闻";
    }
    if (this.listQuery.keyWord == "3") {
      this.title = "健康常识";
    }
  },
  mounted() {
    this.userfrom = window.sessionStorage.getItem("from");
    let listQuery = JSON.parse(this.$route.query.title);
    let section = listQuery.keyWord;
    this.$mybus.emit("userBehavior", {
      from: this.userfrom,
      moduleLevel1: 5,
      moduleLevel2: parseInt(section),
    });

	if (sessionStorage.getItem("msgInfo")) {
          //如果有就读取缓存里面的数据
          this.listQuery.current = Number(sessionStorage.getItem("currentPage"));
          console.log("111", this.currt);
        } else {
          this.listQuery.current = 1;
          //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
          sessionStorage.removeItem("currentPage");
        }

    if (this.listQuery.name) {
      let time = window.sessionStorage.getItem("scroll");
      window.scrollTo(0, time);
    } else {
      window.scrollTo(0, 0);
    }

    this.getdata();

    // let st = document.documentElement.scrollTop || document.body.scrollTop
  },
  destroyed() {
	console.log('销毁')
    sessionStorage.removeItem("msgInfo");
  },
};
</script>

<style >
.backDiv {
  width: 1100px;
  text-align: right;
  margin-bottom: 50px;
}
.backImg {
  width: 140px;
  height: 45px;
  display: inline-block;
  cursor: pointer;
}
.elPagination {
  margin-top: 120px;
}
.all {
  padding-bottom: 80px;
}
.mid {
  width: 50px;
}
.chunk {
  display: flex;
  margin-bottom: 30px;
  justify-content: center;
  cursor: pointer;
}
.middle {
  width: 70%;
  margin: 0 auto;
  min-height: 100vh;
}
.all {
  width: 100%;
}
.middle > span {
  display: block;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 42px;
  margin-top: 68px;
  margin-bottom: 40px;
  text-align: left;
  margin-left: 5%;
}
.chunk > div:nth-child(1) > img {
  width: 340px;
  height: 200px;
}

.right > p:nth-child(1) {
  width: 642px;
  text-align: left;
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 33px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.right > p:nth-child(2) {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6d7278;
  line-height: 20px;
  text-align: left;
  margin-top: 23px;
  margin-bottom: 23px;
}
.right > div:nth-child(3) {
  width: 100%;
  height: 1px;
  background-color: #d8d8d8;
  margin-bottom: 10px;
}
.right > p:nth-child(4) {
  width: 810px;
  height: 60px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6d7278;
  line-height: 30px;
  text-align: left;
}
</style>
